import { useMemo } from 'react';
import { useCalculateJoistAssemblies } from '../calculations/useCalculateJoistAssemblies';
import { useFloorPlanState } from '../../../../../../../stateProviders/FloorPlanStateProvider';

export const JoistsDisplay = () => {

    const floorplanState = useFloorPlanState();
    const numberOfJoistAssembliesNeeded = useCalculateJoistAssemblies();

    const houseAttachedWall = useMemo   ( () => {
        return floorplanState.walls.find( wall => wall.wallType === 'houseAttached')
    },[floorplanState.walls])

    const joistCoordinates = useMemo(() => {
        if (!houseAttachedWall) return [];
    
        // Determine the direction of the house-attached wall
        const axis = houseAttachedWall.x1 === houseAttachedWall.x2 ? 'y' : 'x';
        const joistCoordinates = [];
    
        // Ensure we are always working from the smaller to larger values
        const wallStartX = Math.min(houseAttachedWall.x1, houseAttachedWall.x2);
        const wallStartY = Math.min(houseAttachedWall.y1, houseAttachedWall.y2);
    
        // Number of gaps is number of joists + 1
        const numberOfGaps = numberOfJoistAssembliesNeeded + 1;
        const gapSize = houseAttachedWall.lengthInPixels / numberOfGaps;
    
        for (let i = 1; i <= numberOfJoistAssembliesNeeded; i++) {
            const coordinate = {
                x1: axis === 'y' ? wallStartX : wallStartX + (i * gapSize),
                y1: axis === 'x' ? wallStartY : wallStartY + (i * gapSize),
                x2: 0,
                y2: 0
            };

            let closestDistance = Infinity;
            
            //finds the closest parallel wall to the joist and sets the joist's end point to the intersection point
            floorplanState.walls.forEach( wall => {
                if (axis === 'x') {
                    // Check if the joist's x-coordinate lies within the wall's x1 coordinate
                    if (coordinate.x1 >= wall.x1 && coordinate.x1 <= wall.x2) {
                        const distance = Math.abs(coordinate.y1 - wall.y1);
                        if (distance < closestDistance) {
                            closestDistance = distance;
                            // Update joist's y2 to the intersection point (y at the wall)
                            coordinate.x2 = coordinate.x1,
                            coordinate.y2 = wall.y1
                        }
                    }
                } else if (axis === 'y') {
                    // Check if the joist's y-coordinate lies within the wall's y1 coordinate
                    if (coordinate.y1 >= wall.y1 && coordinate.y1 <= wall.y2) {
                        const distance = Math.abs(coordinate.x1 - wall.x1);
                        if (distance < closestDistance) {
                            closestDistance = distance;
                            // Update joist's x2 to the intersection point (x at the wall)
                            coordinate.x2 = wall.x1,
                            coordinate.y2 = coordinate.y1
                        }
                    }
                }
            });

            joistCoordinates.push(coordinate);
        }
    
        return joistCoordinates;
    
    }, [houseAttachedWall, floorplanState.walls, numberOfJoistAssembliesNeeded]);

    if(!houseAttachedWall){
        //alert('You must have a house attached wall to display joists')
        return
    }

    return (
        joistCoordinates.map( (joist:any, index:number) => {
            console.log(joist)
            return <line key={index} x1={joist.x1} y1={joist.y1} x2={joist.x2} y2={joist.y2} stroke="lightgrey" strokeWidth="2"/>
            return <circle key={index} cx={joist.x1} cy={joist.y1} r={5} fill="lightgrey"/>
        })
    )
}